import { API_END_POINT } from '../utils/constants'
import { getCommonHeaders } from './apiWrapper'

const DEFAULT_STREAM_URL = `${(process.env.REACT_APP_API_GATEWAY_BASE_URL || '').replace(/\/+$/, '')}/aitools/notifications/stream`

const getEnvVar = (key) => {
  try {
    if (typeof process !== 'undefined' && process && process.env) {
      return process.env[key]
    }
  } catch (e) {
    // Ignore error in browser environments where process is undefined
  }
  return undefined
}

export function getNotificationStreamEndpoint() {
  const customUrl = getEnvVar('REACT_APP_NOTIFICATION_STREAM_URL')
  if (customUrl) {
    return customUrl
  }
  const baseUrl = getEnvVar('REACT_APP_API_GATEWAY_BASE_URL') || process.env.REACT_APP_API_GATEWAY_BASE_URL
  const endpoint = API_END_POINT?.aitoolsNotificationStream || 'aitools/notifications/stream'
  return `${baseUrl.replace(/\/+$/, '')}/${endpoint}`
}

export function getNotificationStreamHeaders(custom = {}) {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('access') : ''
  let userId = ''
  try {
    const userStr = localStorage.getItem('user')
    if (userStr) {
      userId = JSON.parse(userStr)?.user_id || JSON.parse(userStr)?.id || ''
    }
  } catch (e) {
    console.warn('[notificationStreamApi] Failed to parse user from localStorage', e)
  }

  const common = getCommonHeaders()
  const lang = common['x-language'] || 'en'
  const finalUserId = userId || common['x-user-id'] || ''

  const headers = {
    Accept: 'text/event-stream',
    'Content-Type': 'application/json',
    'x-user-id': String(finalUserId || ''),
    'x-language': String(lang || 'en'),
    ...common,
    ...custom
  }

  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  return headers
}
